// External Libraries
import * as React from "react";

// Types
import { FilterPill } from "src/components/flexComponents/Hotels/typings";

// Components
import { useLocalization } from "@shared-ui/localization-context";
import { HotelAffinityFilters } from "components/flexComponents/Hotels/components/HotelAffinityFilters/HotelAffinityFilters";

/**
 * @description
 * HotelStarRatingAffinityFilters: Specific Component Filters to Pool Affinity Pages
 */
export const HotelPoolAffinityFilters: React.FC<{}> = () => {
  const { formatText } = useLocalization();

  const filterPills: FilterPill[] = [
    {
      label: formatText("themeSelector.affinity.spa"),
      queryFilter: "&amenities=POOL&amenities=SPA_ON_SITE",
      key: "affinity-filter-spa",
    },
    {
      label: formatText("themeSelector.affinity.waterpark"),
      queryFilter: "&amenities=POOL&amenities=WATER_PARK",
      key: "affinity-filter-waterpark",
    },
    {
      label: formatText("themeSelector.affinity.hottub"),
      queryFilter: "&amenities=POOL&amenities=HOT_TUB",
      key: "affinity-filter-hottub",
    },
    {
      label: formatText("themeSelector.affinity.cheap"),
      queryFilter: "&amenities=POOL&sort=PRICE_LOW_TO_HIGH",
      key: "affinity-filter-cheap",
    },
    {
      label: formatText("themeSelector.affinity.familyfriendly"),
      queryFilter: "&amenities=POOL&travelerType=FAMILY",
      key: "affinity-filter-familyfriendly",
    },
  ];

  return (
    <section className="uitk-type-center all-t-margin-four all-t-padding-one all-b-margin-six all-b-padding-one">
      <p className="uitk-type-heading-300 all-b-margin-two">{formatText("hotels.affinity.filter.message")}</p>
      <HotelAffinityFilters filters={filterPills} />
    </section>
  );
};
